import { Injectable, signal } from '@angular/core';
import { IMarkerToast } from '@app/main/main-content/map/interfaces/marker-toast.interface';

const AUTO_CLEAR_MS = 4000;

@Injectable({ providedIn: 'root' })
export class MarkerToastService {
  private readonly messages = signal<Record<string, IMarkerToast>>({});
  private readonly timers = new Map<string, ReturnType<typeof setTimeout>>();

  public show(markerId: string, message: IMarkerToast): void {
    this.clearTimer(markerId);
    this.messages.update(messages => ({ ...messages, [markerId]: message }));
    this.timers.set(
      markerId,
      setTimeout(() => this.clear(markerId), AUTO_CLEAR_MS)
    );
  }

  public messageFor(markerId: string): IMarkerToast | null {
    return this.messages()[markerId] ?? null;
  }

  private clear(markerId: string): void {
    this.clearTimer(markerId);
    this.messages.update(messages => Object.fromEntries(Object.entries(messages).filter(([id]) => id !== markerId)));
  }

  private clearTimer(markerId: string): void {
    const timer = this.timers.get(markerId);

    if (timer === undefined) return;

    clearTimeout(timer);
    this.timers.delete(markerId);
  }
}
